/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedBillRequest
 */
export interface APIPatchedBillRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedBillRequest
     */
    contract?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPatchedBillRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedBillRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedBillRequest
     */
    amount?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedBillRequest
     */
    paid?: boolean;
}

/**
 * Check if a given object implements the APIPatchedBillRequest interface.
 */
export function instanceOfAPIPatchedBillRequest(value: object): value is APIPatchedBillRequest {
    return true;
}

export function APIPatchedBillRequestFromJSON(json: any): APIPatchedBillRequest {
    return APIPatchedBillRequestFromJSONTyped(json, false);
}

export function APIPatchedBillRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedBillRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contract': json['contract'] == null ? undefined : json['contract'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'paid': json['paid'] == null ? undefined : json['paid'],
    };
}

export function APIPatchedBillRequestToJSON(value?: APIPatchedBillRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contract': value['contract'],
        'editors': value['editors'],
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'paid': value['paid'],
    };
}

